import { getBoggleBadgePointsForLevel, type BoggleBadgeDefinition } from '../types'

export const sorcererBadgeDefinition: BoggleBadgeDefinition = {
  category: 'mastery',
  description: 'Finish a run with Tier V in every category',
  iconId: 'sorcerer',
  id: 'sorcerer',
  level: 'impossible',
  lockedReveal: 'hidden',
  name: 'Sorcerer',
  points: getBoggleBadgePointsForLevel('impossible'),
}
